export const ZAC_VERSION = {
    "version": "4.5.1"
};
